import React from "react";
import { Route, Routes } from "react-router-dom";
import { addFonts } from "./common/assets/Icons";
import "./App.css";
import BankFindApp from "./containers/BankFind";
import BankFindDetails from "./containers/BankFindDetails";
import StructureChange from "./containers/StructureChange";
import BankFindSuite from "./components/BankFindSuite/BankFindSuite";
import FinancialReporting from "./components/FinancialReporting/FinancialReporting";
import HistoricalBankData from "./containers/HistoricalBankData";
import HelpContentCB from "./components/HelpContent/HelpContentCB";
import HelpContentSI from "./components/HelpContent/HelpContentSI";
import HelpContentFailures from "./components/HelpContent/HelpContentFailures";
import BankFailures from "./containers/BankFailures";
import FinancialReportingDetails from "./containers/FinancialReportingDetails";
import Help from "./components/HelpContent/Help";
import StandardComparison from "./containers/StandardComparison";
import CustomizedComparison from "./containers/CustomizedComparison";
import CustomizedSearch from "./containers/CustomizedSearch";
import ManageSavedPeerGroups from "./containers/ManageSavedPeerGroups";
import DefineCustomReport from "./components/PeerGroup/DefineCustomReport";
import DefineCustomPeerGroups from "./containers/DefineCustomPeerGroups";
import BranchOfficeDeposits from "./containers/BranchOfficeDeposits";
import SummaryTables from "./containers/SummaryTables";
import HealthDashboard from "./components/HealthDashboard/HealthDashboard";
import MarketShare from "./containers/MarketShare";
import MaintenanceDashboard from "./components/Maintenance/MaintenanceDashboard";
import CustomDataDownload from "./containers/CustomDataDownload";
import FinancialReportingSearchReport from "./containers/FinancialReportingSearchReport";
import BulkDataApi from "./components/BulkData/BulkDataAPI";
import API101 from "./components/BulkData/API101";
import BulkDataDownload from "./components/BulkData/BulkDataDownload";
import { useQuerySyncEffect } from "./hooks/useQuerySyncEffect";
import SOD from "./containers/SOD";

addFonts();

interface Props {
  uuid: string;
  updateApp: (app: string) => void;
}
function AppWrapper({
  updateApp,
  section,
  children,
}: {
  updateApp: (app: string) => void;
  section: string;
  children: React.ReactNode;
}) {
  React.useEffect(() => {
    updateApp(section);
  }, [section, updateApp]);
  return <>{children}</>;
}
export default function App({ uuid, updateApp }: Props) {
  useQuerySyncEffect();

  return (
    <Routes>
      <Route
        exact
        path={"/bankfind"}
        element={
          <AppWrapper updateApp={updateApp} section="bankFind">
            <BankFindApp />
          </AppWrapper>
        }
        replace="true"
      />
      <Route
        exact
        path="/bankfind/details/:cert"
        element={
          <AppWrapper updateApp={updateApp} section="bankFind">
            <BankFindDetails />
          </AppWrapper>
        }
      />
      <Route
        exact
        path={"/oscr"}
        element={
          <AppWrapper updateApp={updateApp} section="structureChange">
            <StructureChange />
          </AppWrapper>
        }
      />
      <Route
        exact
        path={"/oscr/:eventType"}
        element={
          <AppWrapper updateApp={updateApp} section="structureChange">
            <StructureChange />
          </AppWrapper>
        }
      />
      <Route
        exact
        path={"/financialreporting"}
        element={
          <AppWrapper updateApp={updateApp} section="financialReporting">
            <FinancialReporting />
          </AppWrapper>
        }
      />
      <Route
        exact
        path={"/financialReporting/report"}
        element={
          <AppWrapper updateApp={updateApp} section="financialReporting">
            <FinancialReportingSearchReport />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/financialreporting/details/:cert"
        element={
          <AppWrapper updateApp={updateApp} section="financialReporting">
            <FinancialReportingDetails />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/SOD"
        element={
          <AppWrapper updateApp={updateApp} section="SOD">
            <SOD />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/SOD/branchOffice"
        element={
          <AppWrapper updateApp={updateApp} section="SOD">
            <BranchOfficeDeposits />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/SOD/customDownload"
        element={
          <AppWrapper updateApp={updateApp} section="SOD">
            <CustomDataDownload />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/SOD/summaryTables"
        element={
          <AppWrapper updateApp={updateApp} section="SOD">
            <SummaryTables />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/SOD/marketShare"
        element={
          <AppWrapper updateApp={updateApp} section="SOD">
            <MarketShare />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/peergroup/standard"
        element={
          <AppWrapper updateApp={updateApp} section="peerGroup">
            <StandardComparison />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/peergroup/customized"
        element={
          <AppWrapper updateApp={updateApp} section="peerGroup">
            <CustomizedComparison />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/peergroup/customized/search"
        element={
          <AppWrapper updateApp={updateApp} section="peerGroup">
            <CustomizedSearch />
          </AppWrapper>
        }
      />
      <Route
        path="/peergroup/manage"
        element={
          <AppWrapper updateApp={updateApp} section="peerGroup">
            <ManageSavedPeerGroups />
          </AppWrapper>
        }
      />
      <Route
        path="/peergroup/definegroup"
        element={
          <AppWrapper updateApp={updateApp} section="peerGroup">
            <DefineCustomPeerGroups />
          </AppWrapper>
        }
      />

      <Route
        path="/peergroup/definereport"
        element={
          <AppWrapper updateApp={updateApp} section="peerGroup">
            <DefineCustomReport />
          </AppWrapper>
        }
      />
      <Route
        exact
        path="/historical"
        element={
          <AppWrapper updateApp={updateApp} section="historical">
            <HistoricalBankData />
          </AppWrapper>
        }
      />
      <Route
        path="/historical/help/CB"
        element={
          <AppWrapper updateApp={updateApp} section="historical">
            <HelpContentCB />
          </AppWrapper>
        }
      />
      <Route
        path="/historical/help/SI"
        element={
          <AppWrapper updateApp={updateApp} section="historical">
            <HelpContentSI />
          </AppWrapper>
        }
      />
      <Route
        path="/failures"
        element={
          <AppWrapper updateApp={updateApp} section="failures">
            <BankFailures />
          </AppWrapper>
        }
      />
      <Route
        path="/failures/help"
        element={
          <AppWrapper updateApp={updateApp} section="failures">
            <HelpContentFailures />
          </AppWrapper>
        }
      />
      <Route
        path="/bulkData"
        element={
          <AppWrapper updateApp={updateApp} section="bulkData">
            <BulkDataApi />
          </AppWrapper>
        }
      />
      <Route
        path="/bulkData/api101"
        element={
          <AppWrapper updateApp={updateApp} section="bulkData">
            <API101 />
          </AppWrapper>
        }
      />
      <Route
        path="/bulkData/bulkDataDownload"
        element={
          <AppWrapper updateApp={updateApp} section="bulkData">
            <BulkDataDownload />
          </AppWrapper>
        }
      />
      <Route path="/help" element={<Help />} />
      <Route
        path="/admin/health"
        element={
          <AppWrapper updateApp={updateApp} section="adminHealthDashboard">
            <HealthDashboard />
          </AppWrapper>
        }
      />
      <Route
        path="/admin/maintenance"
        element={
          <AppWrapper updateApp={updateApp} section="maintenanceDashboard">
            <MaintenanceDashboard />
          </AppWrapper>
        }
      />
      <Route path="*" element={<BankFindSuite />} replace="true" />
    </Routes>
  );
}
